import { addClassToIframe, couponsRedirect } from "./custom-component";

export const onRouteUpdate = () => {
  requestAnimationFrame(() => {
    addClassToIframe();
    couponsRedirect();
  });
};